import styled from "styled-components";

export const NavContainer = styled.div`
   gap: 8px;
   display: flex;
   padding: 3px;
   border-radius: 6px;
   background-color: #F5F5F6;
   max-width: max-content;
   margin-top: 20px;
   margin-bottom: 30px;
`

export const NavWrapper = styled.div<{ $active?: boolean }>`
   font-size: 13px;
   font-weight: 500;
   padding: 6px 8px;
   border-radius: 6px;
   box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.04);
   color: #9C9C9F;
   background-color: transparent;
   
   ${({ $active }) => $active ? `
      cursor: default;
      color: #101018;
      background-color: #FFFFFF;
   ` : `
      cursor: pointer;
      &:hover {
         background-color: #F9F9FA;
      }
   `}
`

export const ApiCard = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   padding: 15px 0 16px;
   border-top: 1px solid #F1F1F3;
`

export const ApiLeft = styled.div`
   display: flex;
   align-items: center;
   gap: 12px;

   .icon {
      width: 24px;
      height: 24px;
      border-radius: 999px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      /* background: #F5F5F6; */
      color: #9C9C9F;
   }

   .title { color: #101018; font-weight: 500; }
   .meta { color: #9C9C9F; font-size: 12px; letter-spacing: -0.025em; }
`

export const ApiKey = styled.code`
   font-family: 'Geist Mono', 'Geist', monospace;
   font-size: 12px;
   color: #3F3F45;
   text-decoration-line: underline;
   text-decoration-style: dotted;
   text-decoration-skip-ink: auto;
   text-decoration-color: #6D6D72;
   text-decoration-thickness: 5%;
   text-underline-offset: 10%;
   text-underline-position: from-font;
`

export const ListHead = styled.div`
   display: grid;
   grid-template-columns: 1fr 120px;
   padding: 10px 0;
   font-size: 12px;
   letter-spacing: -0.025em;
   color: #B3B3B6;
`

export const ListRow = styled.div`
   display: grid;
   margin-right: 15px;
   grid-template-columns: 1fr 120px;
   align-items: center;
   padding: 14px 0;
   border-top: 1px solid #F1F1F3;

   .asset {
      display: flex;
      align-items: center;
      gap: 10px;
   }
`

export const CoinIcon = styled.span<{ $bg: string }>`
   width: 20px;
   height: 20px;
   border-radius: 999px;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   background: ${({ $bg }) => $bg};
   color: #fff;
   svg { width: 14px; height: 14px; }
`

export const Ticker = styled.span`
   font-size: 11px;
   letter-spacing: -0.02em;
   color: #9C9C9F;
   background: #F1F1F3;
   border-radius: 999px;
   padding: 2px 6px;
   text-transform: uppercase;
   font-family: 'Geist Mono', 'Geist', monospace;
`

export const Switch = styled.button<{ $on?: boolean }>`
   width: 28px;
   height: 17px;
   border-radius: 999px;
   border: 0;
   background: ${({ $on }) => $on ? '#AF7AD5' : '#E6E6E7'};
   position: relative;
   cursor: pointer;
   transition: background .15s ease;

   &::after {
      content: '';
      position: absolute;
      top: 2px;
      left: ${({ $on }) => $on ? '13px' : '2px'};
      width: 13px;
      height: 13px;
      border-radius: 999px;
      background: #FFFFFF;
      box-shadow: 0 1px 2px rgba(16, 24, 40, 0.24);
      transition: left .15s ease;
   }
`